import React from "react";

import Navbar from "./navBar";
import PortfolioCard from "./reusable/portfolioCard";
import "./styles/portfolio.css";
import ken from "../component/images/ken.jpeg"
import sport from "../component/images/spo.jpeg"
import rent from "../component/images/ren.jpeg"
import space from "../component/images/spa.jpeg"
import port from "../component/images/por.jpeg"

function Portfolio() {
  return (
    <div>
      <Navbar />
      {/* <!-- ======= Portfolio Section ======= --> */}
      <section id="portfolio" className="portfolio">
        <div className="container">
          <div className="section-title">
            <h2>Portfolio</h2>
            <p>My Works</p>
          </div>

          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="portfolio-filters">
                <li className="filter-active">All</li>
                {/* <li className="li-effect">APP</li> */}
                {/* <li className="li-effect-article">ARTICLES</li> */}
                <li className="li-effect">WEB</li>
              </ul>
            </div>
          </div>

          <div className="row portfolio-container">
            <div className="col-lg-4 col-md-6 portfolio-item filter-app">
              <PortfolioCard img={rent} appLink="https://www.olhomes.ng/" appName="Orange Lake Homes"/>
            </div>

            <div className="col-lg-4 col-md-6 portfolio-item filter-web">
              <PortfolioCard img={sport} appLink="https://grand-creponne-5d76e5.netlify.app/" appName="Sportify Clone" category="Web" />
            </div>

            <div className="col-lg-4 col-md-6 portfolio-item filter-app">
              <PortfolioCard img={ken} appLink="https://emmy-shoee.netlify.app/product-preview" appName="Kenga" category="Web" />
            </div>
          </div>
          <br />
          <br />
          <div className="row portfolio-container">
            <div className="col-lg-4 col-md-6 portfolio-item filter-card">
              <PortfolioCard img={space} appLink="https://space-service-delivery.netlify.app/" appName="Space Errands" category="Web" />
            </div>

            <div className="col-lg-4 col-md-6 portfolio-item filter-web">
              <PortfolioCard img={port} appLink="https://sjoportfolio.netlify.app/" appName="Melan" category="Web" />
            </div>

            {/* <div className="col-lg-4 col-md-6 portfolio-item filter-app">
              <PortfolioCard appLink="" appName="Q&A" category="App" />
            </div> */}
          </div>
        </div>
      </section>
      {/* <!-- End Portfolio Section --> */}
      {/* </div> */}
    </div>
  );
}

export default Portfolio;
